import { render, staticRenderFns } from "./VechileManufracturerTable.vue?vue&type=template&id=0ced9a5a&"
import script from "./VechileManufracturerTable.vue?vue&type=script&lang=js&"
export * from "./VechileManufracturerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports